module.exports = __webpack_public_path__ + "static/img/装饰13.b28fe2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/penholder/imgs/装饰13.svg
// module id = TswC
// module chunks = 2